module.exports = __webpack_public_path__ + "static/media/edit-icon-green.92824703.svg";